const Helpers = (function () {
  let helperFunctions = {}

  helperFunctions.documentLocale = () => {
    let locale = document.documentElement.lang;

    if (locale === "") {
      locale = "fr-FR";
    }

    return locale;
  };

  helperFunctions.numberToCurrency = (value, precision) => {
    let parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return "";
    }

    let locale = helperFunctions.documentLocale();
    let parsedPrecision = parseInt(precision);

    if (isNaN(parsedPrecision)) {
      parsedPrecision = 0;
      parsedValue = Math.floor(parsedValue)
    }

    var formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: parsedPrecision,
      maximumFractionDigits: parsedPrecision
    });

    return formatter.format(parsedValue.toFixed(parsedPrecision));
  };

  helperFunctions.signedNumberToCurrency = (value, precision) => {
    const parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return "";
    }

    let parsedPrecision = parseInt(precision);

    if (isNaN(parsedPrecision)) {
      parsedPrecision = 2;
    }

    let formattedValue = helperFunctions.numberToCurrency(Math.abs(parsedValue), parsedPrecision);

    if (parsedValue >= 0) {
      return `+ ${formattedValue}`;
    } else {
      return `- ${formattedValue}`;
    }
  };

  helperFunctions.capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  helperFunctions.debounce = (callback, delay) => {
    var timer;

    return function () {
      var args = arguments;
      var context = this;

      clearTimeout(timer);

      timer = setTimeout(function () {
        callback.apply(context, args);
      }, delay);
    };
  };

  return helperFunctions;
})();

window.Helpers = Helpers;
